import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { ServicesSharedModule } from 'src/app/services/services-shared.module';
import { PlayerEligibilityDialogBoxComponent } from './player-eligibility-dialog-box.component';


@NgModule({
  declarations: [
    PlayerEligibilityDialogBoxComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    ServicesSharedModule,
  ]
})
export class PlayerEligibilityDialogBoxModule { }
